export function create<T extends string>(tagName: T, className?: string | null, container?: HTMLElement): ReturnType<typeof document.createElement> {
  const el = document.createElement(tagName);
  if (className !== undefined && className !== null) el.className = className;
  if (container) container.appendChild(el);
  return el;
}